import { Clock, MapPin, CalendarDays, FileSpreadsheet, Megaphone, Wallet } from "lucide-react";

export const FEATURES = {
  "time-clock": {
    icon: Clock, title: "Employee Time Clock", eyebrow: "Clock in, clock out, sorted",
    intro: "A time clock your team will actually use. One big button to clock in, take a break and clock out — from any phone, tablet or computer.",
    points: [
      ["Server-verified timestamps", "Online clock events use the server's clock, not the device's, so times can't be nudged."],
      ["Breaks built in", "Start and finish paid or unpaid breaks with a single tap."],
      ["Overnight & split shifts", "Shifts that cross midnight and multiple shifts per day are handled properly."],
      ["Full audit history", "Original records are never silently overwritten. Every correction is logged."],
    ],
  },
  "gps-geofencing": {
    icon: MapPin, title: "GPS & Geofencing", eyebrow: "Know they're on site",
    intro: "Draw a geofence around each workplace and decide what happens when someone clocks in from somewhere else.",
    points: [
      ["Map-based setup", "Search the address, drop a pin and set the radius — 150 metres by default."],
      ["Flexible off-site policies", "Block off-site clock-ins, allow and flag them for review, or simply allow them."],
      ["Location checked at clock events", "On the web, location is checked only when someone clocks in or out — not continuously."],
      ["Transparent to staff", "Employees are told when and why their location is used."],
    ],
  },
  rosters: {
    icon: CalendarDays, title: "Staff Rosters", eyebrow: "Plan the week in minutes",
    intro: "A visual weekly roster with drag-and-drop shifts, availability and leave built in.",
    points: [
      ["Drag-and-drop scheduling", "Build the week visually across locations and roles."],
      ["Copy & repeat", "Copy last week's roster or set recurring shifts."],
      ["Availability & leave", "See who's available and spot leave conflicts before you publish."],
      ["Labour cost estimates", "See the estimated cost of the roster as you build it."],
    ],
  },
  timesheets: {
    icon: FileSpreadsheet, title: "Automatic Timesheets", eyebrow: "No more paper timesheets",
    intro: "Every clock-in, break and clock-out flows straight into timesheets — ready to review, approve and export.",
    points: [
      ["Daily, weekly & fortnightly totals", "Ordinary hours, overtime and breaks calculated for you."],
      ["Corrections with a trail", "Employees request corrections; managers approve them. Everything is logged."],
      ["Approve & lock", "Lock approved timesheets so they can't change after payroll."],
      ["CSV & Excel exports", "Export clean data for your payroll system."],
    ],
  },
  announcements: {
    icon: Megaphone, title: "Employee Announcements", eyebrow: "Everyone in the loop",
    intro: "Share staff meetings, training, safety notices and celebrations — and know who's seen them.",
    points: [
      ["Target the right people", "Send to specific staff or workplaces."],
      ["Read receipts & acknowledgements", "See who has read a notice and require sign-off where it matters."],
      ["RSVPs", "Attending, Not attending or Maybe — collected in one place."],
      ["Scheduled publishing", "Write it now, publish it later."],
    ],
  },
  "payroll-reporting": {
    icon: Wallet, title: "Payroll & Reporting", eyebrow: "Numbers you can act on",
    intro: "Configurable Australian pay settings and reports on hours, overtime, attendance and labour costs.",
    points: [
      ["Your pay rules", "Casual, part-time and full-time employees, hourly rates, penalties, overtime and allowances — entered by you."],
      ["Award-ready configuration", "Templates prepared for award setups. You enter and verify the rates."],
      ["Roster vs actual", "Compare planned hours to worked hours."],
      ["Exports", "Download reports and payroll estimates as CSV or Excel."],
    ],
  },
};

export const FEATURE_NAV = [
  ["Time Clock", "/time-clock"], ["GPS & Geofencing", "/gps-geofencing"], ["Rosters", "/rosters"],
  ["Timesheets", "/timesheets"], ["Announcements", "/announcements"], ["Payroll & Reporting", "/payroll-reporting"],
];
